







import { Component, Prop, Vue } from 'vue-property-decorator';

const SVG_URL = '/m/g-icon.svg';

@Component({
  name: 'GIcon'
})
export default class Icon extends Vue {
  @Prop({
    type: String,
    required: true
  })
  iconClass!: string;

  @Prop({
    type: String,
    default: ''
  })
  className!: string;

  get iconName(): string {
    return `${SVG_URL}#${this.iconClass}`;
  }

  get svgClass(): string {
    if (this.className) {
      return 'g-icon ' + this.className;
    } else {
      return 'g-icon';
    }
  }
}
